import React, { ReactNode } from 'react';

/* eslint-disable react/jsx-no-target-blank */

/**
 * Safe link to own external websites only.
 */
const safeExternalLink = ({
  href,
  children,
}: {
    href: string;
    children: ReactNode;
}) => <a href={href} target="_blank">
  {children}
</a>;
export default safeExternalLink;
